/**
 * Arabic copy for the web storefront, keyed by the English it replaces.
 * Wording follows the mobile app (Mobile/src/lib/i18n.js) wherever the same
 * line exists there, so the site and the app read as one product.
 * Arrows point the way Arabic reads.
 */
const AR_STRINGS = {
  /* ── navigation ── */
  'Home': 'الرئيسية',
  'Shop': 'المتجر',
  'Finder': 'ابحث عن عطرك',
  'Account': 'حسابي',
  'Cart': 'الحقيبة',
  'Admin': 'الإدارة',
  'Bag': 'الحقيبة',
  'Bag, {n} items': 'الحقيبة، {n} قطع',
  'Toggle theme': 'تبديل المظهر',
  'Theme': 'المظهر',
  'Theme: Auto (Qatar time)': 'المظهر: تلقائي (بتوقيت قطر)',
  'Theme: Dark': 'المظهر: داكن',
  'Theme: Light': 'المظهر: فاتح',
  'auto': 'تلقائي',
  'light': 'فاتح',
  'dark': 'داكن',

  /* ── Luxe home ── */
  'LUMIÈRE · DOHA': 'لوميير · الدوحة',
  'What will you wear': 'ماذا سترتدي',
  'today?': 'اليوم؟',
  'Search the collection': 'بحث',
  'Find your scent': 'اكتشف عطرك',
  'Pick a mood': 'اختر مزاجك',
  'Warm': 'دافئ',
  'Soft': 'ناعم',
  'Fresh': 'منعش',
  'Elegant': 'أنيق',
  'Smoky': 'دخوني',
  "Today's pick": 'اختيار اليوم',
  "Today's pick: {name}": 'اختيار اليوم: {name}',
  'Discover': 'اكتشف العطر',
  'Add {name} to bag': 'أضف {name} إلى الحقيبة',
  'Collections': 'المجموعات',
  '{n} collections': '{n} مجموعات',
  'Trending': 'الأكثر رواجاً',
  'Help me choose': 'ساعدني أختار',
  'Most ordered': 'الأكثر طلباً',
  'New': 'جديد',
  'On sale': 'عرض خاص',
  'Gift boxes': 'صناديق الهدايا',
  'Velvet cylinder box': 'علبة أسطوانية',
  'with a gold seal': 'مخملية بختم ذهبي',
  'Make it a gift': 'اجعلها هدية',
  'Nothing to show yet.': 'لا توجد نتائج',
  'Perfume bottle': 'زجاجة عطر',
  '{name} bottle': 'زجاجة {name}',
  '{n} ml': '{n} مل',
  'ml': 'مل',

  /* ── the scent ritual ── */
  'SCENT RITUAL': 'طقس العطر',
  'Close': 'إغلاق',
  'Question {n} of 3': 'السؤال {n} من ٣',
  'When do you like your scent to precede you?': 'متى تحب أن يسبقك عطرك؟',
  'Pick the moment closest to you.': 'اختر اللحظة الأقرب إليك.',
  'Morning': 'صباحاً',
  'At work': 'في العمل',
  'Evening': 'مساءً',
  'Occasions': 'في المناسبات',
  'A bright start': 'بداية مشرقة',
  'Quiet presence': 'حضور هادئ',
  'Warmth and mystery': 'دفء وغموض',
  'Unforgettable moments': 'لحظة لا تُنسى',
  'Which olfactive world captivates you?': 'أي عالم عطري يأسرك؟',
  'There is no wrong answer.': 'لا توجد إجابة خاطئة.',
  'Warm woody': 'خشبي دافئ',
  'Soft floral': 'زهري ناعم',
  'Fresh citrus': 'حمضي منعش',
  'Smoky oriental': 'دخوني شرقي',
  'Oud · Amber': 'عود · عنبر',
  'Rose · Jasmine': 'ورد · ياسمين',
  'Bergamot · Lemon': 'برغموت · ليمون',
  'Bakhoor · Sandalwood': 'دخون · صندل',
  'How should its trail feel?': 'كيف تحب أن يكون أثره؟',
  'What impression do you want to leave?': 'أي انطباع تريد أن تتركه؟',
  'Close and intimate': 'قريب وخاص',
  'Balanced': 'متوازن',
  'Bold and striking': 'لافت وجريء',
  'Depends on the day': 'حسب يومي',
  'Noticed up close': 'يُلاحظ عن قرب',
  'Present, never loud': 'حاضر بلا مبالغة',
  'Arrives before you': 'يسبقك إلى المكان',
  'I like variety': 'أحب التنويع',
  'Next': 'التالي',
  'Reveal the result': 'اكشف النتيجة',
  'Previous question': 'السؤال السابق',
  'Your chosen scent': 'عطرك المُختار',
  'match': 'توافق',
  '{n}% match': 'توافق {n}٪',
  'Discover {name}': 'اكتشف {name}',
  'Start the ritual again': 'أعد الطقس من البداية',
  'Nothing to recommend yet.': 'لا توجد نتائج بعد.',

  /* ── product card & shop ── */
  'Save to wishlist': 'احفظ في المفضّلة',
  'Remove from wishlist': 'أزل من المفضّلة',
  'Sold out': 'نفد',
  'Our Collection': 'مجموعتنا',
  'Discover rare fragrances': 'اكتشف العطور النادرة',
  'Rare': 'النادر',
  'Fragrances': 'من العطور',
  'Each fragrance is a unique olfactory journey, crafted from the world\'s rarest ingredients by our master perfumers.': 'كل عطر رحلة فريدة، مصنوع من أندر المكوّنات على أيدي خبرائنا.',
  'Filter': 'تصفية',
  'All': 'الكل',
  'Oud & Wood': 'عود وخشبي',
  'Floral': 'زهري',
  'Oriental': 'شرقي',
  'Search fragrances...': 'ابحث عن عطر...',
  'Sort: Featured': 'الترتيب: المميز',
  'Price: Low → High': 'السعر: من الأقل',
  'Price: High → Low': 'السعر: من الأعلى',
  'Top Rated': 'الأعلى تقييمًا',
  'Newest': 'الأحدث',
  '{n} fragrance found': 'عطر واحد',
  '{n} fragrances found': '{n} عطور',
  'No fragrances match': 'لا توجد نتائج',
  'Recently Viewed': 'شاهدتها مؤخراً',
  'EDP': 'أو دو بارفان',
  'EDT': 'أو دو تواليت',
  'Parfum': 'بارفان',
  'EDC': 'أو دو كولونيا',

  /* ── product page ── */
  'Back to the collection': 'العودة إلى المجموعة',
  'Photo {n}': 'صورة {n}',
  'Zoom photo': 'تكبير الصورة',
  'Previous photo': 'الصورة السابقة',
  'Next photo': 'الصورة التالية',
  '{n} review': 'تقييم واحد',
  '{n} reviews': '{n} تقييمات',
  'Top · first impression': 'الافتتاحية · أول ما تشمّه',
  'Heart · after 30 min': 'القلب · بعد نصف ساعة',
  'Base · lasts for hours': 'القاعدة · يبقى لساعات',
  'Size': 'الحجم',
  ' · Sold out': ' · نفد',
  'Only {n} left in stock': 'متبقٍ {n} فقط',
  'This size is out of stock': 'هذا الحجم غير متوفر',
  'Add to bag': 'أضف إلى الحقيبة',
  'Buy now': 'اشترِ الآن',
  'ABOUT THIS SCENT': 'عن هذا العطر',
  'No description yet.': 'لا يوجد وصف بعد.',
  'THE OTHER SCENTS': 'العطور الأخرى',
  'Free delivery': 'توصيل مجاني',
  'On orders over {x}': 'للطلبات فوق {x}',
  'Gift wrapping': 'تغليف الهدية',
  'Velvet box, complimentary': 'علبة مخملية، مجاناً',
  'Not found': 'غير موجود',
  'This fragrance is no longer in the collection.': 'هذا العطر لم يعد متوفراً في المجموعة.',

  /* ── reviews ── */
  'Customer Reviews': 'آراء العملاء',
  '+ Write a Review': '+ اكتب تقييماً',
  'Your Review': 'تقييمك',
  'Rating *': 'التقييم *',
  'Title': 'العنوان',
  'Summary of your experience': 'خلاصة تجربتك',
  'Review': 'المراجعة',
  'Share your thoughts about this fragrance...': 'شاركنا رأيك في هذا العطر...',
  'Submit Review': 'إرسال',
  'Submitting...': 'جارٍ الإرسال...',
  'Loading reviews...': 'جارٍ تحميل الآراء...',
  'No reviews yet. Be the first to review!': 'لا توجد آراء بعد. كن أول من يقيّم هذا العطر.',
  'Please sign in to leave a review': 'سجّل الدخول لتكتب تقييماً',
  '✅ Review submitted!': 'تم إرسال تقييمك ✓',

  /* ── bag ── */
  'Your bag': 'حقيبتك',
  'One item': 'قطعة واحدة',
  'Two items': 'قطعتان',
  '{n} items': '{n} قطع',
  'Empty': 'فارغة',
  'Your bag is empty for now.\nLet us find your scent.': 'حقيبتك فارغة الآن.\nدعنا نجد عطرك المناسب.',
  'Browse the collection': 'تصفّح المجموعة',
  'Remove {name}': 'أزل {name} من الحقيبة',
  'One fewer': 'تقليل الكمية',
  'One more': 'زيادة الكمية',
  'Delivery': 'التوصيل',
  'Standard': 'عادي',
  'Express': 'سريع',
  'Same-day': 'نفس اليوم',
  'Same Day': 'نفس اليوم',
  '3–5 days': '٣–٥ أيام',
  '1–2 days': '١–٢ يوم',
  'Before 12 PM': 'قبل ١٢ ظهراً',
  'Free': 'مجاني',
  'Free delivery over {x}': 'توصيل مجاني فوق {x}',
  '{x} to go': 'بقي {x}',
  'Velvet box + handwritten card · complimentary': 'علبة مخملية + بطاقة بخط اليد · مجاناً',
  'Ribbon colour': 'لون الشريط',
  'Gold': 'ذهبي',
  'Burgundy': 'عنابي',
  'Black': 'أسود',
  'Card message': 'رسالة على البطاقة',
  'Write a short message': 'اكتب رسالتك القصيرة',
  'Promo code': 'رمز الخصم',
  'Apply': 'تطبيق',
  '{code} applied': 'تم تطبيق {code}',
  'Remove code': 'إزالة الرمز',
  'Subtotal': 'المجموع الفرعي',
  'Discount': 'الخصم',
  'Gift wrap': 'تغليف الهدية',
  'Complimentary': 'مجاناً',
  'Total': 'الإجمالي',
  'Checkout': 'إتمام الطلب',
  'Please select a size': 'اختر الحجم أولاً',
  'Out of stock': 'غير متوفر',
  '{name} added ✓': 'أُضيف {name} ✓',

  /* ── checkout ── */
  'Shipping': 'الشحن',
  'Payment': 'الدفع',
  'Payment Method': 'طريقة الدفع',
  'Order Review': 'مراجعة الطلب',
  'Order Confirmed': 'تم تأكيد الطلب',
  "Your order has been placed. We'll contact you before delivery.": 'تم تقديم طلبك. سنتواصل معك قبل التوصيل.',
  'CONTINUE SHOPPING': 'مواصلة التسوّق',
  'Your Saved Addresses': 'العناوين المحفوظة',
  'USE →': 'استخدم ←',
  'Or Enter New Address': 'أو أدخل عنواناً جديداً',
  'Full Name *': 'الاسم الكامل *',
  'Ahmed Al-Mahmoud': 'أحمد المحمود',
  'Phone': 'الهاتف',
  '+974 XXXX XXXX': '+974 XXXX XXXX',
  'Email *': 'البريد الإلكتروني *',
  '(for order confirmation)': '(لتأكيد الطلب)',
  'you@email.com': 'you@email.com',
  'Checking out as guest.': 'تتسوّق كضيف.',
  'Sign in': 'سجّل الدخول',
  'to save your details for next time.': 'لحفظ بياناتك للمرة القادمة.',
  'Address *': 'العنوان *',
  'Street, Building, Villa/Apt No.': 'الشارع، المبنى، رقم الفيلا/الشقة',
  'City': 'المدينة',
  'Country': 'الدولة',
  'Qatar': 'قطر',
  'UAE': 'الإمارات',
  'Saudi Arabia': 'السعودية',
  'Kuwait': 'الكويت',
  'Shipping Method': 'طريقة التوصيل',
  '3-5 days': '٣–٥ أيام',
  '1-2 days': '١–٢ يوم',
  'Today': 'اليوم',
  'CONTINUE TO PAYMENT →': 'متابعة إلى الدفع ←',
  'Please enter your name': 'يرجى إدخال اسمك',
  'Please enter your address': 'يرجى إدخال عنوانك',
  'Please enter a valid email': 'يرجى إدخال بريد إلكتروني صحيح',
  'Cash on Delivery': 'الدفع عند الاستلام',
  'Pay when your order arrives at your door.': 'ادفع عند وصول طلبك',
  'Credit / Debit Card': 'بطاقة / Apple Pay',
  'Visa, Mastercard, KNET & Apple Pay accepted.': 'دفع آمن عبر MyFatoorah — فيزا، ماستركارد، كي نت وApple Pay.',
  '← BACK': '→ رجوع',
  'REVIEW ORDER →': 'مراجعة الطلب ←',
  'PLACE ORDER': 'تأكيد الطلب',
  'Placing...': 'جارٍ الإرسال...',
  'Complete shipping details': 'أكمل بيانات الشحن',
  'Cart is empty': 'حقيبتك فارغة',
  '❌ Could not create order for payment.': '❌ تعذّر إنشاء الطلب للدفع.',
  '❌ Could not start payment. Please try again.': '❌ تعذّر بدء الدفع. حاول مرة أخرى.',
  '❌ Payment failed:': '❌ فشل الدفع:',
  '🎟️ Discount Code': '🎟️ كود الخصم',
  'Enter code': 'أدخل الكود',

  /* ── orders & tracking ── */
  'My Orders': 'طلباتي',
  '{n} orders': '{n} طلبات',
  'No orders yet': 'لا توجد طلبات بعد',
  'Browse Collection': 'تصفّح المجموعة',
  '{n} item(s)': '{n} قطعة',
  '🚚 Tracking:': '🚚 رقم التتبّع:',
  'Order Tracking': 'التتبّع',
  'Order Placed': 'تم الطلب',
  'We received your order': 'استلمنا طلبك',
  'Processing': 'قيد التحضير',
  'Preparing your fragrance': 'يُجهّز في الدوحة',
  'Shipped': 'في الطريق',
  'On its way to you': 'مع مندوب التوصيل',
  'Out for Delivery': 'يصل اليوم',
  'Delivered': 'تم التوصيل',
  'Order complete': 'استمتع بعطرك',
  'Current': 'الحالية',
  'Items': 'القطع',
  'Delivery Details': 'التوصيل إلى',
  'Payment:': 'الدفع:',
  'Paid ✓': 'مدفوع ✓',
  'Cancelled on': 'أُلغي في',
  '⬇ DOWNLOAD INVOICE (PDF)': '⬇ تنزيل الفاتورة (PDF)',
  'Loading...': 'جارٍ التحميل...',
  'Hide': 'إخفاء',
  'View Details': 'التفاصيل',
  'Cancel Order': 'إلغاء الطلب',
  'Cancelled': 'ملغي',
  'Track Your Order': 'تتبّع طلبك',
  'Track Order': 'تتبّع الطلب',
  'Enter your order number and email — no login needed.': 'أدخل رقم الطلب وبريدك الإلكتروني — دون تسجيل دخول.',
  'Order Number': 'رقم الطلب',
  'Email Address': 'البريد الإلكتروني',
  'LUM-XXXXXXXXX-XXX': 'LUM-XXXXXXXXX-XXX',
  'Searching...': 'جارٍ البحث...',
  'TRACK ORDER': 'تتبّع الطلب',
  '🚚 Tracking Number:': '🚚 رقم التتبّع:',
  'Please enter both order number and email': 'أدخل رقم الطلب والبريد الإلكتروني',
  'Order not found': 'لم يُعثر على الطلب',
  'Please allow popups to download invoice': 'اسمح بالنوافذ المنبثقة لتنزيل الفاتورة',

  /* order status pills — the app's own labels */
  'Pending': 'قيد الانتظار',
  'In progress': 'قيد التنفيذ',
  'Out for delivery': 'خارج للتوصيل',
  'Completed': 'مكتمل',
  'Refunded': 'مسترجع',

  /* ── account ── */
  'Wishlist': 'المفضّلة',
  'My Wishlist': 'المفضّلة',
  'Wishlist is empty': 'لا شيء محفوظ بعد',
  'Browse': 'تصفّح المجموعة',
  'Addresses': 'العناوين',
  'My Addresses': 'العناوين',
  '{n} saved': '{n} محفوظة',
  'Notifications': 'الإشعارات',
  '{n} new': '{n} جديدة',
  'Settings': 'الإعدادات',
  'SIGN OUT': 'تسجيل الخروج',
  'Sign Out': 'تسجيل الخروج',
  'Signed out': 'تم تسجيل الخروج',
  '← Back': '→ رجوع',
  ' · Default': ' · الافتراضي',
  'Remove': 'حذف',
  'Removed': 'تم الحذف',
  '+ Add New Address': '+ أضف عنواناً جديداً',
  'Label': 'التسمية',
  'Office': 'العمل',
  'Other': 'أخرى',
  'Cancel': 'إلغاء',
  'Save': 'حفظ',
  'Saving...': 'جارٍ الحفظ...',
  'Saved!': 'تم الحفظ',
  'Name and address required': 'الاسم والعنوان مطلوبان',
  'Mark all read': 'تعليم الكل كمقروء',
  'No notifications': 'لا توجد إشعارات',
  'Delete': 'حذف',
  'Edit Profile': 'تعديل الملف الشخصي',
  'First Name': 'الاسم الأول',
  'Last Name': 'اسم العائلة',
  'Name required': 'الاسم مطلوب',
  'Updated!': 'تم التحديث',
  'Change Password': 'كلمة المرور',
  'Confirm': 'تأكيد',
  'Update': 'تحديث',
  'Updating...': 'جارٍ التحديث...',
  'Fill all fields': 'يرجى تعبئة جميع الحقول',
  'Passwords do not match': 'كلمتا المرور غير متطابقتين',
  'Password updated!': 'تم تحديث كلمة المرور',
  'Preferences': 'التفضيلات',
  'Currency': 'العملة',
  'Currency:': 'العملة:',
  'Language': 'اللغة',
  'Help': 'المساعدة',
  'FAQ': 'الأسئلة الشائعة',
  'Lumière v2.0 · Made with ❤️ in Qatar': 'Lumière v2.0 · صُنع بحب ❤️ في قطر',

  /* FAQ */
  'What is the return policy?': 'ما سياسة الإرجاع؟',
  'We accept returns within 30 days of delivery for unopened products.': 'نقبل الإرجاع خلال ٣٠ يوماً من التوصيل للمنتجات غير المفتوحة.',
  'How long does delivery take?': 'كم يستغرق التوصيل؟',
  'Standard 3-5 days, Express 1-2 days, Same-day before 12PM in Qatar.': 'العادي ٣–٥ أيام، السريع ١–٢ يوم، ونفس اليوم للطلبات قبل ١٢ ظهراً داخل قطر.',
  'Are all products authentic?': 'هل جميع المنتجات أصلية؟',
  'Yes — 100% genuine, sourced directly from official brand distributors.': 'نعم — أصلية ١٠٠٪، من الموزّعين الرسميين مباشرة.',
  'Can I track my order?': 'هل يمكنني تتبّع طلبي؟',
  'Yes. Once shipped you will get a tracking number by email and in My Orders.': 'نعم. بعد الشحن يصلك رقم التتبّع بالبريد وفي طلباتي.',
  'Do you ship internationally?': 'هل تشحنون خارج قطر؟',
  'Yes — UAE, Saudi Arabia, Kuwait, Bahrain, and Oman.': 'نعم — الإمارات والسعودية والكويت والبحرين وعُمان.',
  'How do I store my perfume?': 'كيف أحفظ عطري؟',
  'Store in a cool dry place away from direct sunlight. Keep the cap on.': 'احفظه في مكان بارد وجاف بعيداً عن الشمس، وأبقِ الغطاء مغلقاً.',

  /* ── sign in ── */
  'Welcome to': 'أهلًا بك في',
  'Sign in to access your orders, wishlist, and exclusive member benefits.': 'سجّل الدخول لتصل إلى طلباتك ومفضّلتك ومزايا الأعضاء.',
  'Reset Password': 'إعادة تعيين كلمة المرور',
  "Enter your email and we'll send you a reset code.": 'سنرسل إلى بريدك رمزاً من ٦ أرقام.',
  'Email address': 'البريد الإلكتروني',
  'Sending...': 'جارٍ الإرسال...',
  'SEND RESET CODE': 'إرسال الرمز',
  'Enter the code sent to': 'أدخل الرمز المرسل إلى',
  'and your new password.': 'وكلمة المرور الجديدة.',
  '6-digit code': 'رمز من ٦ أرقام',
  'New password (min 8 chars)': 'كلمة مرور جديدة (٨ أحرف على الأقل)',
  'Resetting...': 'جارٍ إعادة التعيين...',
  'RESET PASSWORD': 'إعادة التعيين',
  'Resend code': 'لم يصلك؟ أعد الإرسال',
  '← Back to sign in': '→ العودة لتسجيل الدخول',
  'Verify your email': 'تأكيد بريدك الإلكتروني',
  'Enter the 6-digit code we sent to': 'أدخل الرمز المكوّن من ٦ أرقام المرسل إلى',
  'Verifying...': 'جارٍ التحقق...',
  'Verify & Continue': 'تأكيد',
  'Sign in to continue to Lumière': 'سجّل الدخول لمتابعة التسوّق',
  'Join Lumière and start your collection': 'انضم إلى Lumière وابدأ مجموعتك',
  'Sign In': 'تسجيل الدخول',
  'Register': 'حساب جديد',
  'First name': 'الاسم الأول',
  'Last name': 'اسم العائلة',
  'Password': 'كلمة المرور',
  'Please wait...': 'يرجى الانتظار...',
  'SIGN IN': 'تسجيل الدخول',
  'CREATE ACCOUNT': 'إنشاء الحساب',
  'Forgot password?': 'نسيت كلمة المرور؟',
  'or': 'أو',
  'Continue with Google': 'المتابعة عبر Google',
  'Please fill in all fields': 'يرجى تعبئة جميع الحقول',
  '📧 Verification code sent to your email': '📧 أرسلنا رمز التحقق إلى بريدك',
  '📧 Please verify your email — code sent': '📧 يرجى تأكيد بريدك — أرسلنا الرمز',
  'Enter the 6-digit code': 'أدخل الرمز المكوّن من ٦ أرقام',
  '📧 New code sent': '📧 أرسلنا رمزاً جديداً',
  'Enter your email': 'أدخل بريدك الإلكتروني',
  '📧 Reset code sent': '📧 أرسلنا رمز إعادة التعيين',
  'Password must be at least 8 characters': 'يجب أن تكون كلمة المرور ٨ أحرف على الأقل',
  '✅ Password reset! Please sign in': '✅ تمت إعادة التعيين — سجّل الدخول',
  'Login failed': 'تعذّر تسجيل الدخول',
  'Cannot connect': 'تعذّر الاتصال',
  'Verification failed': 'فشل التحقق',
  'Invalid code': 'الرمز غير صحيح',
  'Google login failed': 'تعذّر الدخول عبر Google',
  'Welcome, {name}! ✨': 'أهلًا {name}! ✨',
  'Please sign in': 'يرجى تسجيل الدخول',
  'Error:': 'خطأ:',

  /* ── footer & popup ── */
  'Collection': 'المجموعة',
  'All Fragrances': 'كل العطور',
  'New Arrivals': 'وصل حديثاً',
  'Bestsellers': 'الأكثر مبيعاً',
  'Contact': 'تواصل معنا',
  'Doha, Qatar': 'الدوحة، قطر',
  "Curating the world's finest fragrances for the discerning connoisseur. Maison de Parfum, Doha.": 'نختار أرقى العطور لذوّاقة العطر. دار عطور، الدوحة.',
  'Your email address': 'بريدك الإلكتروني',
  'JOIN': 'اشترك',
  'Please enter your email': 'أدخل بريدك الإلكتروني',
  'Subscribed! ✨': 'تم الاشتراك ✨',
  '© 2026 Lumière Maison de Parfum. All rights reserved.': '© ٢٠٢٦ Lumière دار العطور. جميع الحقوق محفوظة.',
  'MADE WITH ♥ IN QATAR': 'صُنع بحب ♥ في قطر',
  'Limited Time Offer': 'عرض لفترة محدودة',
  'Off Your First Order': 'خصم على طلبك الأول',
  'Use Code': 'استخدم الكود',
  'SHOP NOW': 'تسوّق الآن',
  'LATER': 'لاحقًا',

  /* ── AI concierge ── */
  'AI Fragrance Assistant': 'مستشار العطور',
  'Lumera — Fragrance Advisor': 'لوميرا — مستشارة العطور',
  'AI powered · Always here': 'بالذكاء الاصطناعي · متاحة دائماً',
  'Ask me anything about fragrances...': 'اسأل عن عطر...',
  "Bonjour! I'm Lumera, Lumière's AI fragrance specialist. 🌸\n\nTell me what you're looking for — a mood, an occasion, or who you're shopping for — and I'll find the perfect scent from our collection.": 'أهلًا! أنا لوميرا، مستشارة العطور في Lumière. 🌸\n\nأخبرني عمّا تبحث — مزاج، مناسبة، أو لمن تختار الهدية — وسأجد لك العطر الأنسب من مجموعتنا.',
  "I'm sorry, I couldn't get a response. Please try again.": 'عذرًا — لا توجد إجابة الآن. حاول مرة أخرى.',
  "I'm having trouble connecting right now. Please try again in a moment.": 'عذرًا، تعذّر الوصول إلى المستشار. حاول بعد قليل.',
  'Tap to view →': 'اضغط للعرض ←',
  'Find me something warm & woody': 'أريد عطراً دافئاً وخشبياً',
  'Best for gifting': 'الأفضل كهدية',
  'Something fresh & light': 'عطر منعش وخفيف',
  'Top rated fragrances': 'الأعلى تقييماً',
  'Under QAR 200': 'أقل من ٢٠٠ ر.ق',
  'Something warm & romantic': 'عطر دافئ ورومانسي',
  'Fresh & clean for daily wear': 'منعش ونظيف للاستخدام اليومي',
  'A bold statement fragrance': 'عطر جريء ولافت',
  'Best gift for a woman': 'أفضل هدية لامرأة',
  'Best gift for a man': 'أفضل هدية لرجل',
  'Tell me more': 'أخبرني المزيد',
  'Show me something else': 'اعرض شيئاً آخر',
  'What are your bestsellers?': 'ما الأكثر مبيعاً؟',
  'I want something different': 'أريد شيئاً مختلفاً',

  /* ── admin ── */
  'Access Denied': 'للمسؤولين فقط',
  'You must be an admin to access this page.': 'هذا القسم يتطلب حساب مدير.',
  'Go Home': 'العودة إلى الرئيسية',
  'Dashboard': 'لوحة التحكم',
  'Products': 'المنتجات',
  'Orders': 'الطلبات',
  'Users': 'العملاء',
  'Discounts': 'الخصومات',
  'Popup': 'النافذة',
  'Signed in as': 'مسجّل باسم',
  '📊 Analytics': '📊 الإحصاءات',
  '⬇ Export Analytics': '⬇ تصدير الإحصاءات',
  'Revenue': 'الإيرادات',
  'Customers': 'العملاء',
  "Today's Revenue": 'إيرادات اليوم',
  "Today's Orders": 'طلبات اليوم',
  'Month Revenue': 'إيرادات الشهر',
  'SMTP Test': 'اختبار البريد',
  'Send a test email to verify your email config is working': 'تُرسل تأكيدات الطلب في الخلفية — أرسل رسالة تجريبية للتأكد أن البريد يعمل.',
  'To:': 'إلى:',
  'Send Test Email': 'إرسال بريد تجريبي',
  '✅ Test email sent': '✅ أُرسل البريد التجريبي',
  'Failed to send': 'تعذّر الإرسال',
  'Low Stock Alerts': 'تنبيهات المخزون',
  'Threshold ≤': 'الحد ≤',
  '📧 Email me this': '📧 أرسلها إلى بريدي',
  '📧 Alert emailed ({n} items)': '📧 أُرسل التنبيه ({n} منتجات)',
  'No low-stock items': 'كل المنتجات متوفرة.',
  'Checking stock levels…': 'جارٍ فحص المخزون…',
  'All products are above the threshold. 🎉': 'كل المنتجات متوفرة. 🎉',
  'OUT OF STOCK': 'غير متوفر',
  '{n} left': 'متبقٍ {n}',
  '+ {n} more low on stock': '+ {n} أخرى منخفضة المخزون',
  '🕒 Recent Orders': '🕒 أحدث الطلبات',
  'Order': 'الطلب',
  'Customer': 'العميل',
  'Status': 'الحالة',
  'Amount': 'المبلغ',
  '✓ Locked': '✓ مقفل',
  '✓ Delivered': '✓ تم التوصيل',
  'Updated': 'تم التحديث',
  '✅ Updated': '✅ تم التحديث',
  'Failed': 'فشل',
  '{n} Products': '{n} منتجات',
  '⬇ Template': '⬇ النموذج',
  'Importing...': 'جارٍ الاستيراد...',
  '⬆ Bulk Import': '⬆ استيراد جماعي',
  '+ Add Product': '+ منتج جديد',
  'Imported:': 'تم الاستيراد:',
  'Failed:': 'فشل:',
  'IMG': 'صورة',
  'Product': 'المنتج',
  'Brand': 'العلامة التجارية',
  'Price': 'السعر',
  'Actions': 'الإجراءات',
  'Edit': 'تعديل',
  'Del': 'حذف',
  'Delete "{name}"?': 'حذف «{name}»؟',
  'Deleted': 'تم الحذف',
  'Gallery': 'المعرض',
  '📸 Add Images (first = thumbnail)': '📸 أضف صوراً (الأولى = الصورة الرئيسية)',
  'Uploading...': 'جارٍ الرفع...',
  '{n} image(s) uploaded!': 'تم رفع {n} صور!',
  'Upload failed': 'فشل الرفع',
  'First image becomes thumbnail': 'الصورة الأولى تصبح الرئيسية',
  'No gallery images yet.': 'لا توجد صور بعد.',
  'Name': 'الاسم',
  'Top Notes': 'المقدمة',
  'Heart Notes': 'القلب',
  'Base Notes': 'القاعدة',
  'Description': 'الوصف',
  'Write the product description here...': 'اكتب وصف المنتج هنا...',
  'Price & Stock (QAR)': 'السعر والمخزون (ر.ق)',
  'Price (before)': 'السعر (قبل)',
  'Sale (after)': 'العرض (بعد)',
  'Stock': 'المخزون',
  'e.g. 285': 'مثال: 285',
  'optional': 'اختياري',
  'Blank = unlimited': 'فارغ = غير محدود',
  'Product saved!': 'تم حفظ المنتج!',
  'Brand required': 'العلامة التجارية مطلوبة',
  '100ml price required': 'سعر ١٠٠ مل مطلوب',
  '⬇ Export to CSV/Excel': '⬇ تصدير إلى CSV/Excel',
  '▲ Hide': '▲ إخفاء',
  '▼ Items': '▼ القطع',
  '📦 Delivery Address': '📦 عنوان التوصيل',
  'Name:': 'الاسم:',
  'Phone:': 'الهاتف:',
  'Address:': 'العنوان:',
  'Shipping:': 'الشحن:',
  '🛍️ Order Items': '🛍️ قطع الطلب',
  'Click to load items...': 'اضغط لتحميل القطع...',
  'Discount Codes 🎟️': 'أكواد الخصم 🎟️',
  'Create New Code': 'إنشاء كود جديد',
  'Code *': 'الكود *',
  'Type': 'النوع',
  'Percentage (%)': 'نسبة (%)',
  'Fixed (QAR)': 'مبلغ ثابت (ر.ق)',
  'Value *': 'القيمة *',
  'Min Order (QAR)': 'أقل طلب (ر.ق)',
  'Max Uses': 'أقصى استخدام',
  'Expires At': 'ينتهي في',
  '+ Create Discount Code': '+ إنشاء كود خصم',
  'Code and value required': 'الكود والقيمة مطلوبان',
  'Created!': 'تم الإنشاء!',
  'No discount codes yet': 'لا توجد أكواد خصم',
  'Code': 'الكود',
  'Value': 'القيمة',
  'Uses': 'الاستخدام',
  'Expires': 'ينتهي',
  'Never': 'أبداً',
  'Active': 'نشط',
  'Inactive': 'غير نشط',
  'Disable': 'إيقاف',
  'Enable': 'تفعيل',
  'Activated': 'تم التفعيل',
  'Deactivated': 'تم الإيقاف',
  '{n} Customers': '{n} عملاء',
  '↻ Refresh': '↻ تحديث',
  'No customers yet': 'لا يوجد عملاء بعد',
  'Email': 'البريد',
  'No analytics to export': 'لا توجد إحصاءات للتصدير',
  '✅ Analytics exported': '✅ تم تصدير الإحصاءات',
  'No orders to export': 'لا توجد طلبات للتصدير',
  '✅ Exported {n} orders': '✅ تم تصدير {n} طلبات',
  '✅ Imported {n} product(s)': '✅ تم استيراد {n} منتجات',
  'Add Product': 'منتج جديد',
  'Product Image': 'صورة المنتج',
  'SELECT IMAGE': 'اختر صورة',
  'Name *': 'الاسم *',
  'e.g. Oud Royale': 'مثال: Oud Royale',
  'Brand *': 'العلامة التجارية *',
  'Gender': 'النوع',
  'Unisex': 'للجنسين',
  'Men': 'رجالي',
  'Women': 'نسائي',
  'Concentration': 'التركيز',
  'Category': 'الفئة',
  'Price (QAR)': 'السعر (ر.ق)',
  'Price (before) *': 'السعر (قبل) *',
  'Sale price (after)': 'سعر العرض (بعد)',
  'Sale price should be lower than the regular price.': 'يجب أن يكون سعر العرض أقل من السعر الأصلي.',
  'Customers see {a} with {b} crossed out ({p}% off).': 'يرى العملاء {a} مع شطب {b} (خصم {p}٪).',
  'Description...': 'الوصف...',
  'Save Product': 'حفظ المنتج',
  'Discount %': 'نسبة الخصم %',
  '🎁 Sale Popup': '🎁 نافذة العرض',
  '👁 Preview': '👁 معاينة',
  'Popup Enabled': 'تفعيل النافذة',
  'Show the sale popup to visitors after 1.8 seconds': 'اعرض نافذة العرض للزوار بعد ١٫٨ ثانية',
  'ON': 'مفعّل',
  'OFF': 'متوقف',
  'Popup Content': 'محتوى النافذة',
  'Voucher Code': 'الكود',
  'e.g. WELCOME20': 'مثال: WELCOME20',
  'Top Label': 'العنوان',
  'Sub Label': 'العنوان الفرعي',
  'Button Text': 'نص الزر',
  'Live Preview': 'معاينة',
  '💾 Save Popup Settings': '💾 حفظ النافذة',
  'Popup saved! ✨': 'تم حفظ النافذة ✨',

  /* ── Sept 26 app update: Luxe checkout, legal, account deletion, reports ── */
  'Which scent': 'أي عطر',
  'Today in Doha': 'اليوم في الدوحة',
  'Qatar only': 'داخل قطر فقط',
  'Standard 3-5 days, Express 1-2 days, Same-day in Doha.': 'العادي ٣–٥ أيام، السريع ١–٢ يوم، ونفس اليوم داخل الدوحة.',
  'Back': 'رجوع',
  'Address applied': 'تم اختيار العنوان',
  'Continue to payment': 'متابعة إلى الدفع',
  'Coming soon': 'قريباً',
  'Card payment is on its way. Pay cash on delivery for now.': 'الدفع بالبطاقة قادم قريباً. يمكنك الدفع نقداً عند الاستلام.',
  'Review order': 'مراجعة الطلب',
  'Your order': 'طلبك',
  '{ribbon} ribbon': 'شريط {ribbon}',
  'Delivering to': 'التوصيل إلى',
  'Place order': 'تأكيد الطلب',
  'THANK YOU': 'شكراً لك',
  'confirmed': 'مؤكَّد',
  'Continue shopping': 'مواصلة التسوّق',
  'View my orders': 'عرض طلباتي',
  'Added · View bag': 'أُضيف · عرض الحقيبة',
  'Report': 'إبلاغ',
  'Report this review?': 'الإبلاغ عن هذا التقييم؟',
  "Tell us what's wrong. Our team will look at it, and you won't see this review again.": 'أخبرنا بالمشكلة. سيراجعه فريقنا، ولن يظهر لك هذا التقييم مجدداً.',
  'Spam or misleading': 'مزعج أو مضلِّل',
  'Offensive': 'مسيء',
  'Thank you. We will look at it.': 'شكراً لك، سنراجعه.',
  'Please sign in to report a review': 'سجّل الدخول للإبلاغ عن تقييم',
  'LEGAL': 'الشروط والخصوصية',
  'Privacy Policy': 'سياسة الخصوصية',
  'Terms of Service': 'شروط الخدمة',
  'ACCOUNT': 'الحساب',
  'Permanently delete your account, saved addresses, wishlist and reviews. Past order records are kept, as the law requires.': 'احذف حسابك وعناوينك المحفوظة والمفضلة وتقييماتك نهائياً. نحتفظ بسجلات الطلبات السابقة كما يلزم القانون.',
  'Delete account': 'حذف الحساب',
  'Delete your account?': 'حذف حسابك؟',
  'Your details, addresses, wishlist, bag and reviews will be removed and you will be signed out. This cannot be undone.': 'ستُحذف بياناتك وعناوينك والمفضلة والحقيبة وتقييماتك وسيتم تسجيل خروجك. لا يمكن التراجع عن ذلك.',
  'Your account has been deleted': 'تم حذف حسابك',
  'By creating an account you agree to our ': 'بإنشاء حساب فإنك توافق على ',
  ' and ': ' و',
  'Verify bill': 'التحقق من الفاتورة',
  '▦ DIGITAL BILL — SHOW AT THE DOOR': '▦ الفاتورة الرقمية — أظهرها عند الاستلام',

  /* ── the digital bill and its verification (the app's bill.* / verify.*) ── */
  'View digital bill': 'عرض الفاتورة الرقمية',
  'Your bill': 'فاتورتك',
  'Receipt': 'إيصال',
  'Placed': 'تاريخ الطلب',
  'SCAN TO VERIFY': 'امسح للتحقق',
  'Verified by Lumière at the door': 'يتم التحقق منها عند الاستلام',
  'Save receipt': 'حفظ الإيصال',
  'Done': 'تم',
  'Verify a bill': 'التحقق من فاتورة',
  "Scan the barcode on the customer's bill, or type the code beneath it. The order is then checked against the server.": 'امسح الباركود على فاتورة العميل، أو اكتب الرمز أسفلها. سيتم التحقق من الطلب لدى الخادم.',
  'SCAN A BILL': 'مسح فاتورة',
  'STOP SCANNING': 'إيقاف المسح',
  'CAMERA SCANNING NOT SUPPORTED IN THIS BROWSER': 'المسح بالكاميرا غير مدعوم في هذا المتصفح',
  'OR TYPE THE CODE': 'أو اكتب الرمز',
  'Bill code': 'رمز الفاتورة',
  'CHECK': 'تحقّق',
  'Genuine bill': 'فاتورة صحيحة',
  'Not verified': 'لم يتم التحقق',
  'That is not a Lumière bill code.': 'هذا ليس رمز فاتورة من لوميير.',
  'No order exists for that code.': 'لا يوجد طلب بهذا الرمز.',
  'Could not reach the server. Try again.': 'تعذّر الاتصال بالخادم. حاول مرة أخرى.',
  'Camera access is off. Turn it on in your browser, or type the code instead.': 'الوصول إلى الكاميرا مغلق. فعّله من المتصفح، أو اكتب الرمز بدلاً من ذلك.',
  'No camera on this device. Type the code beneath the barcode instead.': 'لا توجد كاميرا على هذا الجهاز. اكتب الرمز أسفل الباركود بدلاً من ذلك.',
  'CHECK ANOTHER': 'تحقق من فاتورة أخرى',

  /* ── Luxe account, shop and inner pages (the app's account.* / settings.* / shop.*) ── */
  'Main': 'التنقل الرئيسي',
  'OUR COLLECTION': 'مجموعتنا',
  '{n} fragrance': 'عطر واحد',
  '{n} fragrances': '{n} عطور',
  'Sort': 'الترتيب',
  'Clear search': 'مسح البحث',
  'No results': 'لا توجد نتائج',
  'Try another search or clear the filters.': 'جرّب بحثًا آخر أو أزل الفلاتر.',
  'Clear filters': 'مسح الفلاتر',
  'Client since': 'عميل منذ',
  'Administrator': 'مدير',
  'Shopping': 'التسوّق',
  'Products, orders, customers': 'المنتجات والطلبات والعملاء',
  'An order on its way': 'طلب في الطريق',
  'Track and reorder': 'تتبّع وأعد الطلب',
  'Fragrances you saved': 'عطور حفظتها',
  'Where we deliver': 'أين نوصّل',
  'Order updates': 'تحديثات الطلبات',
  'Currency and appearance': 'العملة والمظهر',
  'Saved': 'المحفوظة',
  'Spent': 'الإنفاق',
  'Order received': 'استلمنا طلبك',
  'Being prepared': 'قيد التحضير',
  'On its way': 'في الطريق',
  'Arriving today': 'يصل اليوم',
  'Order placed': 'تم الطلب',
  'Preparing': 'قيد التحضير',
  'Being prepared in Doha': 'يُجهّز في الدوحة',
  'On the way': 'في الطريق',
  'With the courier': 'مع مندوب التوصيل',
  'Enjoy your fragrance': 'استمتع بعطرك',
  'Tracking:': 'رقم التتبّع:',
  'Download invoice (PDF)': 'تنزيل الفاتورة (PDF)',
  'Your orders will appear here after your first one.': 'ستظهر طلباتك هنا بعد أول طلب.',
  'Nothing saved yet': 'لا شيء محفوظ بعد',
  'Tap the heart on any fragrance to keep it here.': 'اضغط على القلب في أي عطر لحفظه هنا.',
  'No saved addresses': 'لا توجد عناوين محفوظة',
  'Add one to check out faster next time.': 'أضف عنوانًا لإتمام الشراء أسرع في المرة القادمة.',
  'Add a new address': 'أضف عنواناً جديداً',
  'Order updates will appear here.': 'ستظهر تحديثات الطلبات هنا.',
  'Unread': 'غير مقروء',
  '8 characters at least.': '٨ أحرف على الأقل.',
  'Appearance': 'المظهر',
  'Auto': 'تلقائي',
  'Light': 'فاتح',
  'Dark': 'داكن',
  'Dark after 6 PM': 'داكن بعد ٦ مساءً',
  'Always ivory': 'عاجي دائمًا',
  'Always night': 'ليلي دائمًا',
  'DELETE ACCOUNT': 'حذف الحساب',
  'Welcome to Lumière': 'أهلًا بك في Lumière',
  'MAISON DE PARFUM · DOHA': 'دار عطور · الدوحة',
  'Create account': 'إنشاء الحساب',
  'Send code': 'إرسال الرمز',
  'Reset password': 'إعادة التعيين',
  'Write a review': 'اكتب تقييماً',
  'Join': 'اشترك',
  'Later': 'لاحقًا',
  'Send': 'إرسال',
  // admin, Luxe
  'Add images': 'إضافة صور',
  'Add your first fragrance, or import a CSV.': 'أضف أول عطر، أو استورد ملف CSV.',
  'Address': 'العنوان',
  'Alert emailed ({n} items)': 'أُرسل التنبيه بالبريد ({n} منتجات)',
  'All products are above the threshold.': 'كل المنتجات فوق الحد.',
  'Analytics': 'التحليلات',
  'Bulk Import': 'استيراد جماعي',
  'Catalogue': 'الكتالوج',
  'Codes you create above are listed here.': 'تظهر هنا الرموز التي تنشئها أعلاه.',
  'Create code': 'إنشاء الرمز',
  'Delivery Address': 'عنوان التوصيل',
  'Discount Codes': 'رموز الخصم',
  'Email health': 'حالة البريد',
  'Email me this': 'أرسلها إلى بريدي',
  'Export': 'تصدير',
  'Export CSV': 'تصدير CSV',
  'Fulfilment': 'التنفيذ',
  'Hide items': 'إخفاء المنتجات',
  'New orders appear here the moment they are placed.': 'تظهر الطلبات الجديدة هنا لحظة تقديمها.',
  'No items found for this order.': 'لا توجد منتجات في هذا الطلب.',
  'No products yet': 'لا توجد منتجات بعد',
  'Notes': 'النفحات',
  'Order Items': 'منتجات الطلب',
  'Overview': 'نظرة عامة',
  'People': 'الأشخاص',
  'People who create an account appear here.': 'يظهر هنا من ينشئ حساباً.',
  'Preview': 'معاينة',
  'Promotions': 'العروض',
  'QAR {n}': '{n} ر.ق',
  'Recent Orders': 'أحدث الطلبات',
  'Refresh': 'تحديث',
  'Sale Popup': 'نافذة العرض',
  'Save popup settings': 'حفظ إعدادات النافذة',
  'Select image': 'اختيار صورة',
  'Send test': 'إرسال تجربة',
  'Storefront': 'واجهة المتجر',
  'Template': 'القالب',
  'Test email sent': 'أُرسل بريد التجربة',
  'Track Your': 'تتبّع',
  'Update status': 'تحديث الحالة',
  'View all': 'عرض الكل',
  'Counter': 'نقطة البيع',
  'Contact us': 'تواصل معنا',
  // from the app, 28 Sep
  'A hidden product stays here but customers cannot see it.': 'يبقى المنتج المخفي هنا لكن العملاء لا يرونه.',
  'About an order': 'بخصوص طلب',
  'About order': 'بخصوص الطلب',
  'Ask the concierge': 'اسأل المستشار',
  'Brand, category, gender and concentration are set when a product is created.': 'العلامة والفئة والجنس والتركيز تُحدَّد عند إنشاء المنتج.',
  'Email us': 'راسلنا بالبريد',
  'Enter a price above 0 for {n} ml': 'أدخل سعراً أكبر من ٠ لحجم {n} مل',
  'Featured': 'مميّز',
  'Include your order number. It starts with LUM- and is on your bill and in My Orders.': 'أرفق رقم طلبك، يبدأ بـ LUM- وتجده في فاتورتك وفي طلباتي.',
  'Instant answers about scents, in English or Arabic': 'إجابات فورية عن العطور، بالعربية أو الإنجليزية',
  'MORE WAYS': 'طرق أخرى',
  'Need help? Contact us': 'تحتاج مساعدة؟ تواصل معنا',
  'Question from the Lumière website': 'سؤال من موقع لوميير',
  'Questions about a fragrance, an order or a delivery: write to us and our team will reply by email.': 'لأي سؤال عن عطر أو طلب أو توصيل، راسلنا وسيرد فريقنا عبر البريد الإلكتروني.',
  'Sale price, 100 ml': 'سعر التخفيض، ١٠٠ مل',
  'Shown in the shop': 'ظاهر في المتجر',
  'The sale price must be above 0 and lower than the 100 ml price.': 'يجب أن يكون سعر التخفيض أكبر من ٠ وأقل من سعر ١٠٠ مل.',
  'This product has no sizes on sale, so there is no price or stock to edit.': 'لا توجد أحجام معروضة لهذا المنتج، فلا يوجد سعر أو مخزون لتعديله.',
  'Unchanged': 'دون تغيير',
  'View bill': 'عرض الفاتورة',
  'We are here to help': 'نحن هنا لمساعدتك',
  'We will mention your order {n} in the subject.': 'سنذكر طلبك {n} في عنوان الرسالة.',
  'Where we are': 'موقعنا',
  'Email, the concierge, where we are': 'البريد، المستشار، موقعنا',
  'Lumera': 'لوميرا',
  'Fragrance advisor · Always here': 'مستشارة العطور · متاحة دائماً',
  // coming soon / launch
  "Something went wrong. Please try again.": "حدث خطأ ما. حاول مرة أخرى.",
  "Our first collection is on its way to Doha. Leave your email and we will tell you the moment we open.": "مجموعتنا الأولى في طريقها إلى الدوحة. اترك بريدك الإلكتروني وسنخبرك لحظة الافتتاح.",
  "Thank you. We will be in touch.": "شكراً لك. سنتواصل معك قريباً.",
  "Notify me": "أبلغني",
  "Tester sign-in": "دخول المختبِرين",
  "For the early-access team. Sign in once and this device will go straight to the shop.": "لفريق الوصول المبكر. سجّل الدخول مرة واحدة وسيفتح هذا الجهاز المتجر مباشرة.",
  "You are signed in as {email}, which is not on the early-access list yet.": "أنت مسجّل الدخول بحساب {email}، وهو غير موجود في قائمة الوصول المبكر بعد.",
  "Saved. The shop shows Coming soon.": "تم الحفظ. المتجر يعرض صفحة «قريباً».",
  "Saved. The shop is open to everyone.": "تم الحفظ. المتجر مفتوح للجميع.",
  "Launch": "الافتتاح",
  "On: visitors see the coming-soon page and cannot order. Admins and testers get the full shop.": "مفعّل: يرى الزوار صفحة «قريباً» ولا يمكنهم الطلب. المشرفون والمختبِرون يرون المتجر كاملاً.",
  "Off: the shop is open to everyone.": "متوقف: المتجر مفتوح للجميع.",
  "Open the shop to everyone now?": "فتح المتجر للجميع الآن؟",
  "Testers": "المختبِرون",
  "One email per line. They sign in once with that email (Google or password) and shop as normal while the site is closed.": "بريد إلكتروني في كل سطر. يسجّلون الدخول مرة واحدة بهذا البريد (Google أو كلمة المرور) ويتسوّقون بشكل طبيعي والموقع مغلق.",
  "Save testers": "حفظ المختبِرين",
  "Waiting list": "قائمة الانتظار",
  "People who left their email on the coming-soon page.": "من تركوا بريدهم الإلكتروني في صفحة «قريباً».",
  "Download CSV": "تنزيل CSV",
  // coming soon, countdown
  "Our first collection is almost ready. The shop opens in": "مجموعتنا الأولى أوشكت على الاكتمال. يفتح المتجر بعد",
  "Time until opening": "الوقت المتبقي على الافتتاح",
  "Opening any moment now.": "الافتتاح في أي لحظة الآن.",
  "Be the first to know when we open.": "كن أول من يعرف عند الافتتاح.",
  "Opening date": "تاريخ الافتتاح",
  "The countdown on the coming-soon page runs to noon, Doha time, on this day.": "العدّ التنازلي في صفحة «قريباً» ينتهي ظهر هذا اليوم بتوقيت الدوحة.",
  "Days": "يوم",
  "Hours": "ساعة",
  "Minutes": "دقيقة",
  "Seconds": "ثانية",
};

export default AR_STRINGS;
